// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1di6r5ow:active{background-color:#a6c5e229}", ""]);
// Exports
module.exports = exports;
